import React from 'react';
import { NavGroup } from '../../components/app/sidebar/NavGroup';

export const StyleGuideNav = {
  title: {
    key: 'style_guide',
    content: 'Style Guide',
    className: 'style-guide',
  },
  content: {
    content: (
      <NavGroup
        items={[
          {
            DistrictWide: false,
            FunctionName: 'Buttons',
            GroupName: 'Style Guide',
            Id: 2,
            IsViewOnlyApplicable: 'N',
            MenuName: '',
            Ordinal: 2,
            PathUrlSegment: '/styleguide/buttons',
            ReadAccess: true,
            SubGroupName: null,
            WriteAccess: true,
          },
          {
            DistrictWide: false,
            FunctionName: 'Forms',
            GroupName: 'Style Guide',
            Id: 2,
            IsViewOnlyApplicable: 'N',
            MenuName: '',
            Ordinal: 3,
            PathUrlSegment: '/styleguide/forms',
            ReadAccess: true,
            SubGroupName: null,
            WriteAccess: true,
          },
          {
            DistrictWide: false,
            FunctionName: 'Tables',
            GroupName: 'Style Guide',
            Id: 2,
            IsViewOnlyApplicable: 'N',
            MenuName: '',
            Ordinal: 4,
            PathUrlSegment: '/styleguide/tables',
            ReadAccess: true,
            SubGroupName: null,
            WriteAccess: true,
          },
        ]}
      />
    ),
    key: 'content_style_guide',
  },
  key: 'according_style_guide',
};



// WEBPACK FOOTER //
// ./src/common/Constants/styleguide.js